/**
 * PIM (Privileged Identity Management) session and activation types.
 * COMP-005: Just-in-time privileged access via PIM for Groups.
 * Uses JIT eligibility + selfActivate model with app-managed approval workflow.
 */
export const PIM_SESSION_STATUSES = [
    "Activating",
    "Active",
    "Failed",
    "Expired",
    "Deactivating",
    "Revoking",
    "RevocationPending",
    "Revoked",
    "PendingApproval",
    "ApprovalExpired",
];
export const APPROVAL_MODES = ["self", "single", "two-person"];
/**
 * Status of an individual approval request.
 */
export const APPROVAL_REQUEST_STATUSES = [
    "Pending",
    "Approved",
    "Denied",
    "Expired",
];
//# sourceMappingURL=pim.js.map